import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_ENDPOINTS } from "./api/config";

const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap";
document.head.appendChild(fontLink);

const css = `
  .su-root *, .su-root *::before, .su-root *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .su-root {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #1a1a1a;
  }

  /* RIGHT brand panel */
  .su-right {
    background: #1a1a1a;
    display: flex; flex-direction: column;
    justify-content: center; align-items: center;
    padding: 4rem 3rem;
    position: relative; overflow: hidden;
    order: 2;
  }
  .su-right::before {
    content: '';
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 600px; height: 600px; border-radius: 50%;
    border: 1px solid rgba(201,168,76,0.07);
  }
  .su-right::after {
    content: '';
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 340px; height: 340px; border-radius: 50%;
    border: 1px solid rgba(201,168,76,0.12);
  }
  .su-right-inner { position: relative; z-index: 1; max-width: 380px; text-align: center; }
  .su-panel-tag {
    font-size: 0.65rem; font-weight: 500; letter-spacing: 0.18em;
    text-transform: uppercase; color: #c9a84c; margin-bottom: 1.5rem;
  }
  .su-panel-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 2.4rem; font-weight: 600; line-height: 1.1;
    color: #f5f0e8; margin-bottom: 1rem;
  }
  .su-panel-title em { font-style: italic; }
  .su-panel-text {
    font-size: 0.85rem; font-weight: 300;
    color: rgba(245,240,232,0.5); line-height: 1.8; margin-bottom: 2.5rem;
  }
  .su-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; text-align: left; margin-bottom: 2.5rem; }
  .su-stat-box {
    border: 1px solid rgba(201,168,76,0.2);
    border-radius: 2px; padding: 1.25rem;
  }
  .su-stat-n {
    font-family: 'Cormorant Garamond', serif;
    font-size: 2rem; font-weight: 600; color: #f5f0e8; line-height: 1;
    margin-bottom: 4px;
  }
  .su-stat-l {
    font-size: 0.7rem; font-weight: 300; color: rgba(245,240,232,0.4);
    letter-spacing: 0.05em;
  }
  .su-panel-signin {
    font-size: 0.82rem; color: rgba(245,240,232,0.5);
  }
  .su-panel-signin a { color: #c9a84c; text-decoration: none; font-weight: 500; }
  .su-panel-signin a:hover { text-decoration: underline; }

  /* LEFT form panel */
  .su-left {
    background: #f5f0e8;
    display: flex; flex-direction: column;
    padding: 2.5rem 4rem;
    position: relative; overflow: hidden;
    order: 1;
  }
  .su-left::before {
    content: '';
    position: absolute; top: -80px; right: -80px;
    width: 250px; height: 250px; border-radius: 50%;
    border: 1px solid rgba(201,168,76,0.12);
  }
  .su-logo {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.7rem; font-weight: 600; color: #1a1a1a;
    text-decoration: none; display: inline-block;
    margin-bottom: 2rem;
  }
  .su-logo span { color: #c9a84c; }
  .su-eyebrow {
    font-size: 0.65rem; font-weight: 500; letter-spacing: 0.18em;
    text-transform: uppercase; color: #c9a84c; margin-bottom: 0.75rem;
    display: flex; align-items: center; gap: 0.6rem;
  }
  .su-eyebrow::before { content: ''; display: block; width: 1.5rem; height: 1px; background: #c9a84c; }
  .su-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 2.4rem; font-weight: 600; line-height: 1.1;
    color: #1a1a1a; margin-bottom: 1.5rem;
  }
  .su-title em { font-style: italic; color: #c9a84c; }

  /* ROLE TOGGLE */
  .su-role-toggle {
    display: grid; grid-template-columns: 1fr 1fr;
    gap: 0; border: 1px solid rgba(26,26,26,0.15);
    border-radius: 2px; overflow: hidden;
    margin-bottom: 1.75rem;
  }
  .su-role-btn {
    padding: 0.85rem 1rem; background: #fff;
    border: none; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.78rem; font-weight: 400;
    color: #888; transition: all 0.2s ease;
    display: flex; flex-direction: column; align-items: center; gap: 4px;
  }
  .su-role-btn:first-child { border-right: 1px solid rgba(26,26,26,0.1); }
  .su-role-btn.active {
    background: #1a1a1a; color: #f5f0e8;
  }
  .su-role-icon { font-size: 1.2rem; }
  .su-role-name { font-weight: 500; letter-spacing: 0.05em; }
  .su-role-desc { font-size: 0.68rem; opacity: 0.65; }

  /* FORM FIELDS */
  .su-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
  .su-field { margin-bottom: 1.1rem; }
  .su-label {
    display: block; font-size: 0.68rem; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: #555; margin-bottom: 0.45rem;
  }
  .su-input {
    width: 100%; padding: 0.8rem 1rem;
    background: #fff; border: 1px solid rgba(26,26,26,0.15);
    border-radius: 2px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.88rem; font-weight: 300;
    color: #1a1a1a; outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    -webkit-appearance: none;
  }
  .su-input:focus { border-color: #c9a84c; box-shadow: 0 0 0 3px rgba(201,168,76,0.1); }
  .su-input::placeholder { color: #bbb; }
  .su-select {
    width: 100%; padding: 0.8rem 1rem;
    background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23aaa' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 1rem center;
    border: 1px solid rgba(26,26,26,0.15); border-radius: 2px;
    font-family: 'DM Sans', sans-serif; font-size: 0.88rem; font-weight: 300;
    color: #1a1a1a; outline: none; cursor: pointer;
    -webkit-appearance: none; appearance: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .su-select:focus { border-color: #c9a84c; box-shadow: 0 0 0 3px rgba(201,168,76,0.1); }
  .su-input-wrap { position: relative; }
  .su-eye-btn {
    position: absolute; right: 0.75rem; top: 50%;
    transform: translateY(-50%);
    background: none; border: none; cursor: pointer;
    color: #aaa; font-size: 0.85rem; padding: 4px;
    transition: color 0.2s;
  }
  .su-eye-btn:hover { color: #c9a84c; }

  /* PASSWORD STRENGTH */
  .su-pw-strength { display: flex; gap: 4px; margin-top: 6px; }
  .su-pw-bar {
    height: 3px; flex: 1; border-radius: 2px;
    background: rgba(26,26,26,0.1); transition: background 0.3s;
  }
  .su-pw-bar.weak { background: #e74c3c; }
  .su-pw-bar.fair { background: #f39c12; }
  .su-pw-bar.strong { background: #27ae60; }
  .su-pw-hint { font-size: 0.68rem; color: #aaa; margin-top: 4px; }

  /* TERMS */
  .su-terms {
    display: flex; align-items: flex-start; gap: 0.75rem;
    margin-bottom: 1.25rem;
  }
  .su-checkbox {
    width: 16px; height: 16px; flex-shrink: 0;
    border: 1px solid rgba(26,26,26,0.25); border-radius: 2px;
    background: #fff; cursor: pointer;
    accent-color: #1a1a1a; margin-top: 2px;
  }
  .su-terms-text {
    font-size: 0.78rem; font-weight: 300; color: #777; line-height: 1.5;
  }
  .su-terms-text a { color: #c9a84c; text-decoration: none; }

  /* SUBMIT */
  .su-btn {
    width: 100%; padding: 1rem;
    background: #1a1a1a; color: #f5f0e8;
    border: none; border-radius: 2px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.75rem; font-weight: 500;
    letter-spacing: 0.12em; text-transform: uppercase;
    cursor: pointer; transition: all 0.25s ease;
    display: flex; align-items: center; justify-content: center; gap: 0.5rem;
  }
  .su-btn:hover { background: #c9a84c; color: #1a1a1a; }
  .su-btn:disabled { opacity: 0.55; cursor: not-allowed; }

  .su-divider {
    display: flex; align-items: center; gap: 1rem;
    margin: 1.25rem 0;
  }
  .su-divider::before, .su-divider::after {
    content: ''; flex: 1; height: 1px; background: rgba(26,26,26,0.1);
  }
  .su-divider span { font-size: 0.72rem; color: #aaa; letter-spacing: 0.08em; }

  .su-switch { text-align: center; font-size: 0.82rem; color: #777; }
  .su-switch a { color: #c9a84c; text-decoration: none; font-weight: 500; }
  .su-switch a:hover { text-decoration: underline; }

  .su-error {
    background: #fdf0f0; border: 1px solid rgba(220,50,50,0.2);
    border-radius: 2px; padding: 0.75rem 1rem;
    font-size: 0.8rem; color: #c0392b;
    margin-bottom: 1.25rem;
    display: flex; align-items: center; gap: 0.5rem;
  }
  .su-success {
    background: #f0faf4; border: 1px solid rgba(39,174,96,0.2);
    border-radius: 2px; padding: 1rem;
    font-size: 0.85rem; color: #27ae60;
    margin-bottom: 1.25rem; text-align: center; line-height: 1.6;
  }

  @keyframes suFadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .su-role-fields { animation: suFadeUp 0.3s ease both; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .su-spinner {
    width: 16px; height: 16px; border-radius: 50%;
    border: 2px solid rgba(245,240,232,0.3);
    border-top-color: #f5f0e8;
    animation: spin 0.7s linear infinite;
  }

  @media (max-width: 900px) {
    .su-root { grid-template-columns: 1fr; }
    .su-right { display: none; }
    .su-left { padding: 2rem; order: 1; }
    .su-grid2 { grid-template-columns: 1fr; }
  }
`;

const SPECIALISATIONS = [
  "Aesthetic Clinical Trainers",
  "Aesthetic Dermatology Medical Representative",
  "Aesthetic Dermatology Sales Manager",
  "Aesthetic Marketing Interns/Marketing Specialist",
  "Aesthetician",
  "Back Office Staff",
  "Beauty Related Products Consultant",
  "Beauty Related Products Retailer",
  "Beauty Therapist",
  "Cleaner",
  "Cosmetic Dermatologist",
  "Eye Brows and Lashes Specialist",
  "Front Office Staff",
  "Hair Specialist",
  "Make Up Artist",
  "Massage Therapist",
  "Medical Aesthetician",
  "Nail Technician",
  "Skin Care Sales Executive",
  "Spa Therapist",
  "Towel Girl/ Hair Washer",
  "Waxing Professional",
  "Other"
];

const CITIES = [
  "Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret",
  "Kampala", "Dar es Salaam", "Kigali", "Addis Ababa", "Other"
];

function pwStrength(pw) {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return score;
}

export default function SignUp() {
  const navigate = useNavigate();
// export default function SignUp({ onNavigate }) {
  const [role, setRole] = useState("jobseeker"); // "jobseeker" | "employer"
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", phone: "",
    city: "", password: "", confirmPassword: "",
    // job seeker
    specialisation: "",
    // employer
    businessName: "", businessType: "",
  });
  const [showPw, setShowPw] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  if (typeof document !== "undefined" && !document.getElementById("bl-su-css")) {
    const s = document.createElement("style");
    s.id = "bl-su-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const strength = pwStrength(form.password);
  const strengthLabel = ["", "Weak", "Fair", "Good", "Strong"][strength] || "";
  const strengthColor = ["", "weak", "fair", "strong", "strong"][strength] || "";

  const validate = () => {
    if (!form.firstName || !form.lastName) return "Please enter your full name.";
    if (!form.email.includes("@")) return "Please enter a valid email address.";
    if (!form.phone) return "Please enter your phone number.";
    if (!form.city) return "Please select your city.";
    if (form.password.length < 8) return "Password must be at least 8 characters.";
    if (form.password !== form.confirmPassword) return "Passwords do not match.";
    if (role === "jobseeker" && !form.specialisation) return "Please select your specialisation.";
    if (role === "employer" && !form.businessName) return "Please enter your business name.";
    if (!agreed) return "Please accept the terms and conditions.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const err = validate();
    if (err) { setError(err); return; }
    setLoading(true);
    // TODO: connect to .NET Core API — POST /api/auth/register
    try {
      const response = await fetch(API_ENDPOINTS.REGISTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          role: role // "jobseeker" or "employer"
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed");
      }

      setSuccess(true);
      setSuccessMessage(data.message || "Account created successfully! Check your email to verify your address.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="su-root">
      {/* LEFT — form */}
      <div className="su-left">
        <Link to="/" className="su-logo">Rembo<span>List</span></Link>
        <div className="su-eyebrow">Create Your Account</div>
        <h1 className="su-title">Join the<br /><em>community</em></h1>


        
        {success ? (
          // <div className="su-success">
          //   
          //   Check your email to verify your address, then{" "}
          //   <a href="#" style={{ color: "#27ae60" }} onClick={e => { e.preventDefault(); navigate("/signin"); }}>sign in here</a>.
          // </div>
          

          <div className="su-success-container jsd-fade">
            {/* Big Icon or Visual Cue */}
            <div className="su-success-icon" style={{ fontSize: '3rem', marginBottom: '1rem' }}>
              ✉️
            </div>

            <div className="si-success-msg">
              <span>✦</span> {successMessage || "Registration successful!"}
            </div>

            <div className="su-verification-notice" style={{ margin: '1.5rem 0', textAlign: 'center' }}>
              <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#333' }}>
                Verify your email address
              </h3>
              <p style={{ color: '#666', lineHeight: '1.5', marginTop: '0.5rem' }}>
                We've sent a verification link to your email. 
                <strong> You must verify your account</strong> before you can sign in to the dashboard.
              </p>
              
              <div style={{ 
                background: '#fff9e6', 
                padding: '0.75rem', 
                borderRadius: '8px', 
                fontSize: '0.9rem', 
                color: '#856404',
                marginTop: '1rem',
                border: '1px solid #ffeeba' 
              }}>
                <i className="fa fa-info-circle me-2"></i>
                Don't see it? Check your <strong>Spam</strong> or <strong>Promotions</strong> folder.
              </div>
            </div>

            <button className="si-btn" onClick={() => navigate("/signin")}>
              Continue to Sign In
            </button>
          </div>
        )
        : (
          <>
            {/* ROLE SELECTOR */}
            <div className="su-role-toggle">
              <button
                type="button"
                className={`su-role-btn${role === "jobseeker" ? " active" : ""}`}
                onClick={() => setRole("jobseeker")}
              >
                <span className="su-role-icon">✦</span>
                <span className="su-role-name">Job Seeker</span>
                <span className="su-role-desc">I'm looking for work</span>
              </button>
              <button
                type="button"
                className={`su-role-btn${role === "employer" ? " active" : ""}`}
                onClick={() => setRole("employer")}
              >
                <span className="su-role-icon">◈</span>
                <span className="su-role-name">Employer</span>
                <span className="su-role-desc">I'm hiring talent</span>
              </button>
            </div>

            {error && <div className="su-error"><span>⚠</span>{error}</div>}

            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div className="su-grid2">
                <div className="su-field">
                  <label className="su-label">First Name</label>
                  <input className="su-input" placeholder="Amara" value={form.firstName} onChange={set("firstName")} />
                </div>
                <div className="su-field">
                  <label className="su-label">Last Name</label>
                  <input className="su-input" placeholder="Osei" value={form.lastName} onChange={set("lastName")} />
                </div>
              </div>

              {/* Email + Phone */}
              <div className="su-grid2">
                <div className="su-field">
                  <label className="su-label">Email Address</label>
                  <input className="su-input" type="email" placeholder="you@example.com" value={form.email} onChange={set("email")} />
                </div>
                <div className="su-field">
                  <label className="su-label">Phone Number</label>
                  <input className="su-input" type="tel" placeholder="+254 700 000 000" value={form.phone} onChange={set("phone")} />
                </div>
              </div>

              {/* City */}
              <div className="su-field">
                <label className="su-label">City</label>
                <select className="su-select" value={form.city} onChange={set("city")}>
                  <option value="">Select your city</option>
                  {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>

              {/* Role-specific fields */}
              <div className="su-role-fields" key={role}>
                {role === "jobseeker" ? (
                  <div className="su-field">
                    <label className="su-label">Specialisation</label>
                    <select className="su-select" value={form.specialisation} onChange={set("specialisation")}>
                      <option value="">Select your specialisation</option>
                      {SPECIALISATIONS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                ) : (
                  <div className="su-grid2">
                    <div className="su-field">
                      <label className="su-label">Business Name</label>
                      <input className="su-input" placeholder="Luxe Hair Studio" value={form.businessName} onChange={set("businessName")} />
                    </div>
                    <div className="su-field">
                      <label className="su-label">Business Type</label>
                      <select className="su-select" value={form.businessType} onChange={set("businessType")}>
                        <option value="">Select type</option>
                        <option>Salon</option>
                        <option>Spa</option>
                        <option>Medical Spa</option>
                        <option>Barbershop</option>
                        <option>Nail Parlor</option>
                        <option>Pharmacy/Chemist</option>
                        <option>Beauty Shop</option>
                        <option>Beauty Training Institution</option>
                        <option>Dental Clinic - Botox Provider</option>
                        <option>Specialist Clinic</option>
                        <option>Other</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {/* Password */}
              <div className="su-grid2">
                <div className="su-field">
                  <label className="su-label">Password</label>
                  <div className="su-input-wrap">
                    <input
                      className="su-input"
                      type={showPw ? "text" : "password"}
                      placeholder="Min. 8 characters"
                      value={form.password}
                      onChange={set("password")}
                      style={{ paddingRight: "2.5rem" }}
                    />
                    <button type="button" className="su-eye-btn" onClick={() => setShowPw(v => !v)}>
                      {showPw ? "🙈" : "👁"}
                    </button>
                  </div>
                  {form.password && (
                    <>
                      <div className="su-pw-strength">
                        {[1,2,3,4].map(i => (
                          <div key={i} className={`su-pw-bar${i <= strength ? " " + strengthColor : ""}`} />
                        ))}
                      </div>
                      <div className="su-pw-hint">{strengthLabel} password</div>
                    </>
                  )}
                </div>
                <div className="su-field">
                  <label className="su-label">Confirm Password</label>
                  <input
                    className="su-input"
                    type="password"
                    placeholder="Repeat password"
                    value={form.confirmPassword}
                    onChange={set("confirmPassword")}
                  />
                </div>
              </div>

              {/* Terms */}
              <div className="su-terms">
                <input
                  type="checkbox" className="su-checkbox"
                  checked={agreed} onChange={e => setAgreed(e.target.checked)}
                  id="su-terms"
                />
                <label htmlFor="su-terms" className="su-terms-text">
                  I agree to RemboList's <a href="#">Terms of Service</a> and{" "}
                  <a href="#">Privacy Policy</a>. I understand my data will be used to match me with relevant opportunities.
                </label>
              </div>

              <button className="su-btn" type="submit" disabled={loading}>
                {loading ? <span className="su-spinner" /> : null}
                {loading ? "Creating account…" : `Create ${role === "employer" ? "Employer" : "Job Seeker"} Account`}
              </button>
            </form>

            <div className="su-divider"><span>or</span></div>
            <div className="su-switch">
              Already have an account?{" "}
              <a href="#" onClick={e => { e.preventDefault(); navigate("/signin"); }}>Sign in</a>
            </div>
          </>
        )}
      </div>

      {/* RIGHT — brand panel */}
      <div className="su-right">
        <div className="su-right-inner">
          <div className="su-panel-tag">Join RemboList Today</div>
          <h2 className="su-panel-title">
            {role === "employer"
              ? <>Find your next<br /><em>star hire</em></>
              : <>Land your dream<br /><em>role</em></>
            }
          </h2>
          <p className="su-panel-text">
            {role === "employer"
              ? "Post your roles and connect with verified, skilled beauty professionals across East Africa."
              : "Showcase your portfolio and get matched with salons and spas that value your craft."
            }
          </p>
          {/* <div className="su-stats">
            <div className="su-stat-box">
              <div className="su-stat-n">1,200+</div>
              <div className="su-stat-l">Active listings</div>
            </div>
            <div className="su-stat-box">
              <div className="su-stat-n">8,500+</div>
              <div className="su-stat-l">Professionals</div>
            </div>
            <div className="su-stat-box">
              <div className="su-stat-n">3,200+</div>
              <div className="su-stat-l">Hires made</div>
            </div>
            <div className="su-stat-box">
              <div className="su-stat-n">4.8★</div>
              <div className="su-stat-l">Platform rating</div>
            </div>
          </div> */}
          <div className="su-panel-signin">
            Already have an account?{" "}
            <a href="#" onClick={e => { e.preventDefault(); navigate("/signin"); }}>Sign in here</a>
          </div>
        </div>
      </div>
    </div>
  );
}
